import React, { useEffect, useState } from "react";
import axios from "axios";
import "./AddToFavourites.css";
import { Button, Snackbar, Alert, CircularProgress } from "@mui/material";
// import DeleteIcon from '@mui/icons-material/Delete';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const Favourites = () => {
  const [favourites, setFavourites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const fetchFavourites = async () => {
    try {
      const userID = localStorage.getItem("userId");
      if (!userID) {
        console.error("User ID missing");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_KEY}/cart/fetch?userID=${userID}`
      );
      // const response = await axios.get(
      //   `http://localhost:8000/cart/fetch?userID=${userID}`
      // );
      console.log("API Response:", response.data);
      setFavourites(response.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching favourites:", error);
      setLoading(false);
    }
  };

  const removeFavourite = async (productId) => {
    try {
      const userID = localStorage.getItem("userId");
      await axios.delete(`${process.env.REACT_APP_API_KEY}/cart/remove`, {
        data: {
          userID,
          product_id: productId,
        },
      });
      setSnackbarMessage("Product Removed from favourites!");
      setOpenSnackbar(true);
      setFavourites((prevFavourites) => {
        const updatedFavourites = prevFavourites.filter((item) => item.product_id !== productId);
        console.log("Updated favourites:", updatedFavourites);
        return updatedFavourites;
      });
    } catch (error) {
      console.error("Error removing favourite:", error);
    }
  };

  useEffect(() => {
    fetchFavourites();
    document.body.classList.add("hide-scrollbar");
    return () => document.body.classList.remove("hide-scrollbar");
  }, []);

  return (
    <div className="favourites-container">
      <h1 className="title">Favourites ❤️</h1>
      {loading ? (
        <div className="loader" >
          <CircularProgress sx={{color:"black"}}/>
        </div>
      ) : favourites.length === 0 ? (
        <p className="empty-text">No products found.</p>
      ) : (
        <div className="favourites-grid">
          {favourites.map((item) => {
            const imageSrc = item.image_code
              ? `data:image/png;base64,${item.image_code}`
              : "";

            return (
              <div key={item.ID} className="favourite-card">
                {imageSrc ? (
                  <img
                    src={imageSrc}
                    alt={item.product_name}
                    className="product-image"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200x250?text=No+Image";
                    }}
                  />
                ) : (
                  <p>No image available</p>
                )}
                <h3 className="product-name">{item.product_name}</h3>
                <p className="brand-name">{item.brand_name}</p>
                <div className="buttons-row">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="buy-button-link"
                  >
                    <Button
                      variant="contained"
                      className="buy-button"
                      sx={{
                        backgroundColor: "#a41847",
                        textTransform: "lowercase",
                        fontFamily: "niavhFont"
                      }}
                    >
                      buy now 
                    </Button>
                  </a>
                  <Button
                    variant="outlined"
                    color="error"
                    className="remove-button"
                    sx={{
                      fontFamily: "niavhFont",
                    }}
                    onClick={() => removeFavourite(item.product_id)}
                  >
                    remove
                     {/* <DeleteIcon sx={{ fontSize: 18 }} /> */}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="info" variant="filled" onClose={() => setOpenSnackbar(false)}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Favourites;